export default "__VITE_ASSET__DuhqVz9P__"